import { Heading, Grid, Text, Box } from '@simplywallst/ui-core';

import { getStaticUrl, useCloudflareImage } from '@/hooks/useCloudflareImage';

const Tile = ({ title, src }: { title: string; src: string }) => (
  <Box backgroundColor="spaceGray" borderRadius="x2" overflow="hidden">
    <Grid templateRows="auto 80px" alignItems="center">
      <img alt={title} src={src} />
      <Text typography="xSmallStrong" textAlign="center">
        {title}
      </Text>
    </Grid>
  </Box>
);

export const FooterBanner = () => {
  const dividendsUSP = useCloudflareImage({
    src: getStaticUrl('portfolio/feature-usp/dividends-usp.png'),
  });

  const risksUSP = useCloudflareImage({
    src: getStaticUrl('portfolio/feature-usp/risks-usp.png'),
  });

  const valuationUSP = useCloudflareImage({
    src: getStaticUrl('portfolio/feature-usp/valuation-usp.png'),
  });

  const returnsUSP = useCloudflareImage({
    src: getStaticUrl('portfolio/feature-usp/returns-usp.png'),
  });
  return (
    <Box backgroundColor="noir" borderRadiusLg="x1">
      <Box padding="x4" paddingMd="x6">
        <Heading as="h4" typography="smallStrong" textAlign="center">
          More exciting features are coming to help you grow and protect your
          portfolio
        </Heading>
      </Box>
      <Box
        paddingX="x8"
        paddingBottom="x8"
        paddingXMd="x6"
        paddingBottomMd="x6"
      >
        <Grid
          templateColumns="1fr"
          templateColumnsSm="repeat(2, 1fr)"
          templateColumnsMd="repeat(4, 1fr)"
          gap="24px"
        >
          <Tile title="Track your returns in detail" src={returnsUSP} />
          <Tile title="Identify opportunities" src={valuationUSP} />
          <Tile title="Prevent risks" src={risksUSP} />
          <Tile title="Track dividends" src={dividendsUSP} />
        </Grid>
      </Box>
    </Box>
  );
};
